import React from "react";
import { Tooltip } from "react-tooltip";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { DataPoints } from "./DataPoints";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import FutureDataToggle from "./FutureDataToggle";
import NoData from "../../../../components/noData/noData";

export const SectionToggleWrapper = ({
  children,
  title,
  data,
  currencySymbol,
  idForConfigurator,
  wrappedColumns = ["Staff Name", "Product Name", "Revenue Category"],
  isLoading,
  fileName,
  futureData,
  ...restTableProps
}) => {
  const addTooltip = (header, formattedValue) =>
    wrappedColumns.includes(header) && formattedValue.length > 26 ? (
      <div
        className="wrapped-text"
        data-tooltip-id="table-rows-tooltip-id"
        data-tooltip-content={formattedValue}
      >
        {formattedValue}
      </div>
    ) : (
      formattedValue
    );

  const historical = data?.tableInfo?.data?.length ? (
    <>
      {data?.dataPoints ? (
        <DataPoints dataPoints={data.dataPoints} currencySymbol={currencySymbol} />
      ) : null}

      <Tooltip id="table-rows-tooltip-id" />

      <TableWithCustomSearch
        data={data.tableInfo.data}
        colHeaders={data.tableInfo.colHeaders}
        columns={data.tableInfo.columns}
        rawDataLink={data?.rawDataLink}
        filterName={title}
        showCount={false}
        tableWrapperId="client-info"
        fileName={fileName}
        customFn={(header, formattedValue) => addTooltip(header, formattedValue)}
        {...restTableProps}
      />
    </>
  ) : (
    <NoData />
  );

  const content = () => {
    if (children) return children;
    if (futureData)
      return (
        <>
          <FutureDataToggle {...futureData} addTooltip={addTooltip} />
          {historical}
        </>
      );
    return historical;
  };

  return (
    <span id={`${idForConfigurator}ModuleWrapper`} className="moduleWrapper">
      <SectionToggle autoHeight title={title} content={content()} isLoading={isLoading} />
    </span>
  );
};
